// extracted by mini-css-extract-plugin
export default {"langCard":"LanguagePage_langCard__uipHm"};